import { Box, Button, Card, Link, Typography } from "@mui/material";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useAuth } from "../../hooks/useAuth";
import ImageItem from "./imageItem";
import CustomAvatar from "../../component/CustomAvatar";

interface ModeratedContentProps {
  postContent: string;
  images: (File | string)[];
  handleDelete: () => void;
  handleEdit: () => void;
}

const ModeratedContent: React.FC<ModeratedContentProps> = (props) => {
  const { postContent, images, handleDelete, handleEdit } = props;
  const { authUser } = useAuth();

  return (
    <Box
      sx={{
        px: {xs: 2, sm: 5, },
        py: 2.5,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 3,
        // maxWidth: {xs: '364px', md: '620px' },
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          width: "100%",
          gap: 0.75,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            width: "100%",
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <WarningAmberIcon color="error"/>
          <Typography variant="h5">
            We can't post this!
          </Typography>
        </Box>
        <Typography variant="body1" align='center' color='text.secondary'>
          Your post seems to violate one or more of our safety guidelines. Please review our <Link href={'/moderation'} target="_blank" color='primary'>Moderation Policy</Link> for more information.
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: "100%",
          gap: 2,
        }}
      >
        <Box
          sx={{
            px: 2.5,
            py: 2.5,
            width: "100%",
            backgroundColor: (theme) => theme.palette.background["paper-elevation-9"],
            borderRadius: (theme) => theme.shape.borderRadiusMd,
            border: '1px solid',
            borderColor: (theme) => theme.palette.primary._states.outlinedBorder,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              width: "100%",
            }}
          >
            <CustomAvatar
              src={authUser?.profilePicUrl}
              sx={{ width: 48, height: 48 }}
            />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
              }}
            >
              <Typography variant='body1'>
                {postContent}
              </Typography>
              {
                images.map((image, index) => (
                  <Box
                    key={index}
                    sx={{
                      height: '100%',
                      // display: 'inline-block'
                    }}
                  >
                    {
                      (typeof image === 'string') ?
                      <ImageItem
                        image={image}
                        alt={`image-${index}`}
                      /> :
                      <ImageItem
                        image={URL.createObjectURL(image)}
                        alt={`image-${index}`}
                      />
                    }
                  </Box>
                ))
              }
            </Box>
          </Box>
        </Box>

        <Typography variant='body1' align='center' color='text.secondary'>
          Did we get this wrong? <Link href={'mailto:support@soopra.ai'} color='primary'>Email Us</Link> so we can improve.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            width: "100%",
            justifyContent: "center",
            gap: 1.5,
          }}
        >
          <Button variant="contained" color="error" size="large"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleDelete();
            }}
          >
            Delete
          </Button>
          <Button variant="contained" size="large"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleEdit();
            }}
          >
            Edit Post
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default ModeratedContent;
